import { SewaOnboardingListItem } from '@percent/admin-dashboard/api/actions/sewaOnboarding/sewaOnboarding.types'

export const MOCK_SEWA_ORG_ID_1 = 'staging_organisation_test_row_1'
export const MOCK_SEWA_ORG_ID_2 = 'staging_organisation_test_row_2'

export const mockSewaOnboardingListItems: SewaOnboardingListItem[] = [
  {
    organisationId: MOCK_SEWA_ORG_ID_1,
    sewa: {
      onboardedAt: '2024-01-15T10:00:00.000Z',
      onboardedBy: 'admin_one@goodstack.io'
    }
  },
  {
    organisationId: MOCK_SEWA_ORG_ID_2,
    sewa: {
      onboardedAt: '2024-02-20T12:00:00.000Z',
      onboardedBy: 'admin_two@goodstack.io'
    }
  }
]

export const mockSewaOnboardingListResponse = {
  data: mockSewaOnboardingListItems,
  object: 'sewa_onboarding',
  totalResults: mockSewaOnboardingListItems.length,
  pageSize: 25,
  _links: {
    current: 'https://staging-api.poweredbypercent.com/v1/admin/organisations/sewa-onboarding'
  }
}
